<template>
  <div>
    <header-title title="SUPPORT" />
    <div class="support">
      <h2>Support</h2>
      <p>For any questions or help, please contact <a href="mailto:joseph@swiftor.com">joseph@swiftor.com</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'support',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {},
  methods: {}
}
</script>

<style scoped>
  .support {
    text-align: center;
    margin: 40px;
  }

  .support h2 {
    margin-bottom: 20px;
  }

  .support p {
    font-size: 16px;
  }

  .support a {
    color: #069;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Support.vue